var _rect, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddCustomer = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_new_customer",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 46,
    height: 46,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28274",
    "data-name": "Group 28274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61157",
    "data-name": "Path 61157",
    d: "M27.7,18.7A9.009,9.009,0,1,0,14,11a9.071,9.071,0,0,0,4.3,7.7A16.978,16.978,0,0,0,6,35v6H8V35a15,15,0,0,1,30,0v6h2V35A16.978,16.978,0,0,0,27.7,18.7ZM16,11a7,7,0,1,1,7,7A6.957,6.957,0,0,1,16,11Z",
    fill: "#d7272f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61158",
    "data-name": "Path 61158",
    d: "M24,30H22v3H19v2h3v3h2V35h3V33H24Z",
    fill: "#d7272f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61159",
    "data-name": "Path 61159",
    d: "M23,25a9,9,0,1,0,9,9A8.963,8.963,0,0,0,23,25Zm0,16a7,7,0,1,1,7-7A6.957,6.957,0,0,1,23,41Z",
    fill: "#d7272f"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddCustomer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-customer.e0c9b41e.svg";
export { ForwardRef as ReactComponent };